import { render, staticRenderFns } from "./EditInfo.vue?vue&type=template&id=3957635d&lang=pug&"
import script from "./EditInfo.vue?vue&type=script&lang=ts&"
export * from "./EditInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports